var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "header",
    { staticClass: "site-header flex justify-content-between" },
    [
      _c("div", { staticClass: "flex" }, [
        _c(
          "a",
          {
            staticClass: "nav-toggle",
            attrs: { href: "#" },
            on: {
              click: function ($event) {
                return _vm.mixinGoToRouter("home")
              },
            },
          },
          [_vm._m(0)]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "nav-toggle",
            attrs: { href: "#" },
            on: { click: _vm.onNavToggle },
          },
          [_vm._m(1)]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("div", { staticClass: "search_panel" }, [
            _c("input", {
              staticClass: "form-control",
              attrs: { type: "search", placeholder: "Поиск по меню..." },
              on: { keyup: _vm.search, blur: _vm.search },
            }),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "action-list flex" },
            [
              _vm.isAllowToShow("noSMSUpdate")
                ? _c(
                    "div",
                    {
                      staticClass: "d-none d-lg-block",
                      staticStyle: { "padding-right": "10px" },
                    },
                    [
                      _c("p", { staticClass: "badge badge-danger" }, [
                        _vm._v("новые SMS не поступают!"),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mr-4 ml-2" },
                [
                  _vm.$currentUserRoles &&
                  (_vm.$currentUserRoles.includes("manager") ||
                    _vm.$currentUserRoles.includes("managerAssist"))
                    ? _c("SelectWorkShift")
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "login-data d-none d-lg-block" }, [
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm.$currentUser && _vm.$currentUser.nick_name)
                  ),
                ]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.$currentUser.login))]),
              ]),
              _vm._v(" "),
              _vm.$currentUserRoles &&
              (_vm.$currentUserRoles.includes("manager") ||
                _vm.$currentUserRoles.includes("managerAssist"))
                ? _c("div", { staticClass: "p-l-10" }, [
                    _c(
                      "a",
                      { attrs: { href: "#" }, on: { click: _vm.callToNumber } },
                      [_c("i", { staticClass: "icon-fa icon-fa-phone-square" })]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("NotificationList"),
              _vm._v(" "),
              _c("ul", { staticClass: "action-list" }, [
                _c(
                  "li",
                  [
                    _c(
                      "v-dropdown",
                      { attrs: { "show-arrow": false } },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "avatar",
                            attrs: {
                              slot: "activator",
                              href: "#",
                              "data-toggle": "dropdown",
                              "aria-haspopup": "true",
                              "aria-expanded": "false",
                            },
                            slot: "activator",
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: "/assets/img/avatars/avatar.png",
                                alt: "Avatar",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("v-dropdown-item", [
                          _c("span", { staticClass: "manager_name" }, [
                            _vm._v(
                              _vm._s(_vm.$currentUser && _vm.$currentUser.name)
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.openUserSettings.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "icon-fa icon-fa-cogs" }),
                              _vm._v(" Настройки\n              "),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("v-dropdown-item", [
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.logout.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "icon-fa icon-fa-sign-out",
                              }),
                              _vm._v(" Выход\n              "),
                            ]
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _vm.openModalPhoneCall
            ? _c("ModalPhoneCallByNumber", {
                attrs: { closeModal: () => (_vm.openModalPhoneCall = false) },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "hamburger hamburger--arrowturn" }, [
      _c("div", { staticClass: "hamburger-box text-center" }, [
        _c("i", { staticClass: "icon-fa icon-fa-home fs-22" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "hamburger hamburger--arrowturn" }, [
      _c("div", { staticClass: "hamburger-box" }, [
        _c("div", { staticClass: "hamburger-inner" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }